import * as React from 'react';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import { SYNC_FILTER_OPTIONS } from './expenseTypes';

const styles = require('./recordStyles.pcss');

type Props = {
  labelId: string;
  filterSyncStatus: string;
  filterDateFrom: string;
  filterDateTo: string;
  onSyncStatusChange: (value: string) => void;
  onDateFromChange: (value: string) => void;
  onDateToChange: (value: string) => void;
  onApply: () => void;
  onReset: () => void;
};

const SyncStatusFilterBar = (props: Props) => {
  return (
    <div className={styles.filterBar}>
      <FormControl size="small" className={styles.filterFormControl}>
        <InputLabel id={props.labelId}>Sync Status</InputLabel>
        <Select
          labelId={props.labelId}
          value={props.filterSyncStatus}
          label="Sync Status"
          onChange={(e) => props.onSyncStatusChange(e.target.value as string)}
        >
          {SYNC_FILTER_OPTIONS.map((opt) => (
            <MenuItem key={opt.value} value={opt.value}>
              {opt.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      <TextField
        size="small"
        label="Date From"
        type="date"
        value={props.filterDateFrom}
        onChange={(e) => props.onDateFromChange(e.target.value)}
        InputLabelProps={{ shrink: true }}
      />

      <TextField
        size="small"
        label="Date To"
        type="date"
        value={props.filterDateTo}
        onChange={(e) => props.onDateToChange(e.target.value)}
        InputLabelProps={{ shrink: true }}
      />

      <Button variant="contained" size="small" onClick={props.onApply}>
        Apply
      </Button>
      <Button variant="outlined" size="small" onClick={props.onReset}>
        Reset
      </Button>
    </div>
  );
};

export default SyncStatusFilterBar;
